import React, { useEffect, useRef } from "react";

import Swiper from "swiper";
import { Navigation, EffectFade, FreeMode, Keyboard } from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/keyboard";

const EventsCarousel = ({ html, setIsEditingPreferences }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            const swiper = new Swiper(swiperRef.current, {
                modules: [Navigation, Keyboard, FreeMode],
                speed: 1000,
                slidesPerView: 1, // Mobile
                spaceBetween: 20,
                grabCursor: true,
                containerRole: `region`,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    // Desktop.
                    576: {
                        slidesPerView: 2,
                    },
                },
            });

            return () => swiper.destroy(); // clean up on unmount
        }
    }, [html]);

    return (
        <>
            <div className="picked-flex">
                <h2 className="section__heading">Picked for you</h2>

                <button className="" onClick={() => setIsEditingPreferences(true)}>
                    Edit preferences
                </button>
            </div>

            <div className="swiper" data-carousel="event-feed" ref={swiperRef}>
                <button className="swiper-button-prev">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="33"
                        viewBox="0 0 34 33"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.4884 29.3741L18.5241 30.4097L16.4528 32.481L15.4171 31.4454L1.87047 17.8988H1.71189V17.7402L1.44119 17.4695L0.405521 16.4339L1.44119 15.3982L1.71189 15.1275V14.9695H1.86988L15.4171 1.42238L16.4528 0.386719L18.5241 2.45805L17.4884 3.49371L6.01254 14.9695H32.5256V17.8988H6.01313L17.4884 29.3741Z"
                            fill="black"
                        />
                    </svg>
                </button>

                <button className="swiper-button-next">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="33"
                        viewBox="0 0 34 33"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.907 29.3741L15.8713 30.4097L17.9426 32.481L18.9783 31.4454L32.5249 17.8988H32.6835V17.7402L32.9542 17.4695L33.9899 16.4339L32.9542 15.3982L32.6835 15.1275V14.9695H32.5255L18.9783 1.42238L17.9426 0.386719L15.8713 2.45805L16.907 3.49371L28.3828 14.9695H1.8698V17.8988H28.3823L16.907 29.3741Z"
                            fill="black"
                        />
                    </svg>
                </button>

                <div
                    className="swiper-wrapper"
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </>

    );
};

export default EventsCarousel;
